export function setOrganizationAudienceRules(state, rules = {}) {
  const {
    affiliationTypes = [],
    branches = [],
    subgroups = [],
  } = rules;
  state.audience_rules = {
    ...state.audience_rules,
    affiliationTypes,
    branches,
    subgroups,
  };
}
